import { useMutation } from '@apollo/client';
import {
  ALL_TABLES,
  COMMON_CONSTANTS,
  EventEmitter,
  getAllColumnWidth,
  getCurrentUserHook,
  getDateOperators,
  getDifference,
  getTranslatedText,
  SuperList,
  toast,
  useProduct,
  useSuperListHook,
  useUserMSPCheckHook
} from '@nile/components';
import {
  TicketClient,
  UPDATE_TICKET,
  GET_PERSONALIZATION_BY_NAME,
  AccountClient
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import {
  CustomCheckboxCell,
  CustomRadioCell,
  CustomSecureTextCell,
  CustomSelectCell,
  CustomTextCell,
  CustomTimeCell,
  DateTimeCell,
  HoursMinutesCell,
  PriorityCell,
  ProgressCell,
  SubjectCell,
  TimerCell
} from '@nile/mangifera/src/Components/Ticket';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import {
  getAccessor,
  getColumnWidth,
  getDependantField,
  getParentField,
  getType,
  getWidthFromPersonalization,
  isClearable,
  isDependantField,
  isEditable,
  isFilterable,
  isSortable,
  getTicketFields,
  getQueryVariables
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  checkDynamicQuery,
  fetchValues,
  generateOptions,
  getAllowedProperties,
  getAsyncOptions,
  getDefaultValue,
  getDynamicQuery,
  getKeyName,
  getMethodName
} from '@nile/mangifera/src/Pebbles/TicketToolbar';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { cloneDeep, isEmpty, merge, omit } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { defaultPersonalization } from '../../Constants/Tickets';
// import InlineEditTextCell from '@nile/mangifera/src/Components/Ticket/InlineEditTextCell';
import InlineEditTextCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditTextCellV2';
// import InlineEditDualCell from '@nile/mangifera/src/Components/Ticket/InlineEditDualCell';
import {
  getWindowId,
  useIsAuthorisedHook
} from '@nile/components/src/Utils/helpers';
import InlineEditDualCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditDualCellV2';
import NewInlineStatusCell from '@nile/mangifera/src/Components/Ticket/NewInlineStatusCell';
import ClosureModal from '../../Components/Ticket/ClosureModal';
import { useCachedQuery } from '@nile/graphql/src/QueryManager/api';

function TicketContainerNew(props) {
  const { ticketViewMeta, intl, match, allEntities, ticketViews } = props;
  const flags = useFlags();
  const user = getCurrentUserHook();
  const windowId = getWindowId();

  const dynamicPaginationFlag = flags?.dynamicPaginationTickets;
  const context = useContext(TicketContext);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const isTicketEditAuthorised = useIsAuthorisedHook('tickets.edit');

  const [data, setData] = useState([]);
  const dataByRef = React.useRef([]);
  dataByRef.current = data;

  const [closureSaveLoading, setClosureSaveLoading] = useState(false);
  const [columnGroup, setColumnGroup] = useState(null);
  const tableName = ALL_TABLES.tickets;

  const viewId = match.params.id;

  const activeView = ticketViews.find((item) => {
    return item.id === viewId;
  });

  const activeViewByRef = React.useRef(null);
  activeViewByRef.current = activeView;

  const columnWidthObject = getAllColumnWidth(tableName);
  const isMSP = useUserMSPCheckHook();

  const [editCellId, setEditCellId] = useState(null);
  const setEditCell = (cellId) => {
    setEditCellId(cellId || null);
  };

  const {
    records,
    setRecords,
    listInfo,
    tableCondition,
    updateTableFilterCondition,
    advanceFilterCondition
  } = useSuperListHook({
    tableName,
    viewId
  });

  const DEFAULT_SORT = {
    attribute: 'createdTime',
    order: 'DESC'
  };

  const [closureModalactive, setClosureModalActive] = useState(false);
  const [showLiveUpdate, setShowLiveUpdate] = useState(false);
  const [isLiveUpdating, setIsLiveUpdating] = useState(false);
  const isLiveUpdatingRef = React.useRef(null);
  isLiveUpdatingRef.current = isLiveUpdating;
  const liveUpdateTicketListRef = React.useRef([]);
  const [errorsOnClosure, setErrorsOnClosure] = useState(null);
  const errorsOnClosureByRef = React.useRef(null);
  errorsOnClosureByRef.current = errorsOnClosure;

  const { sortAttributes } = ticketViewMeta;

  const ticketAttributes = allEntities.find((item) => {
    return item.name === 'Ticket';
  }).attributes;

  const defaultColumn = React.useMemo(() => {
    return {
      minWidth: 30,
      maxWidth: 500,
      width: 150,
      Priority: PriorityCell,
      HTML: SubjectCell,
      Text: InlineEditTextCellV2,
      Timer: TimerCell,
      Status: NewInlineStatusCell,
      DateTime: DateTimeCell,
      Dependant: InlineEditTextCellV2,
      Dual: InlineEditDualCellV2,
      Progress: ProgressCell,
      CustomTime: CustomTimeCell,
      CustomText: CustomTextCell,
      CustomRadio: CustomRadioCell,
      CustomCheckbox: CustomCheckboxCell,
      CustomSelect: CustomSelectCell,
      HoursMinutes: HoursMinutesCell,
      SecureText: CustomSecureTextCell
    };
  }, []);

  const handleClickOutside = (e) => {
    // temp for class checking to avoid closing the dropdown
    if (
      (e.target.classList &&
        e.target.classList.contains('value_selector__option')) ||
      e.target.classList.contains('react-select-label') ||
      e?.target?.classList?.contains('select-option') ||
      e?.target?.classList?.contains('Superops-Badge--badgeIcon') || // For clicking on badge icon from status dropdown
      e?.target?.classList?.contains('Superops-Badge') // For clicking on badge from status dropdown
    ) {
      return;
    }
    setEditCell(null);
  };

  const freezeCellCheck = (cellData) => {
    const rowData = cellData.row.original;
    if (cellData.column.Header === 'Status') return false;
    return rowData.client === null || (!isMSPProduct && rowData.site === null);
  };

  const isCheckBoxInactive = (rowData) => {
    switch (activeViewByRef?.current?.systemViewProperty) {
      case 'UNKNOWN_TICKET':
      case 'TRASH_TICKET':
        return false;
      default:
        return rowData.client === null;
    }
  };

  const [ticketListLoading, setTicketListLoading] = useState(true);

  const coulumsRef = React.useRef(null);

  const getColumnsPersonalisation = (cols) => {
    const personalisedData = cols?.getPersonalizationByCategoryAndName?.value;
    if (personalisedData) {
      context.setPersonalization(personalisedData);
      coulumsRef.current = JSON.parse(personalisedData);
      return JSON.parse(personalisedData);
    }
    const defaultCols = defaultPersonalization(isMSPProduct, isMSP);
    coulumsRef.current = defaultCols;
    context.setPersonalization(JSON.stringify(defaultCols));
    return defaultCols;
  };

  const fetchViewData = async (cols) => {
    setTicketListLoading(true);
    const allColumns = getColumnsPersonalisation(cols);

    const allowedProperties = getAllowedProperties(props.allEntities, intl);
    const filteredCols = [];
    allColumns.map((el) => {
      ticketAttributes.forEach((c) => {
        if (el.name === c.name) {
          filteredCols.push({
            ...el,
            nestedTo: c?.nestedTo,
            isDependent: c?.isDependent,
            nestedAttributes: c?.nestedAttributes,
            label: getTranslatedText(intl, c.label),
            filterType: c.filterType
          });
        }
      });
    });

    const columns = filteredCols.map((col, idx) => {
      return {
        Header: col.label,
        header: col.label,
        accessor: getAccessor(col),
        accessorKey: getAccessor(col),
        minSize: getColumnWidth(col.name).minWidth,
        size: getWidthFromPersonalization(col.name, columnWidthObject),
        type: getType(col),
        id: col.name,
        superIndex: idx,
        disableResizing: false,
        className: 'sticky',
        disableSortBy: !isSortable(col, sortAttributes),
        editable: viewId !== '9' && isTicketEditAuthorised && isEditable(col),
        // editable: false,
        clearable: viewId !== '9' && isTicketEditAuthorised && isClearable(col),
        disableFilters: !isFilterable(allowedProperties, col),
        shouldFreezeCell: freezeCellCheck,
        setEditCell: setEditCell,
        helpers: {
          getDefaultValue,
          getDynamicQuery,
          checkDynamicQuery,
          generateOptions,
          getMethodName,
          getKeyName,
          getDateOperators,
          getVariables: () => {},
          fetchValues,
          getAsyncOptions,
          updateConditions: updateTableFilterCondition
        },
        actions: getActions(col),
        field: {
          ...col,
          parent: ticketAttributes?.find((attr) => attr?.name === col?.nestedTo)
        },
        meta: {
          ticketAttributes
        },
        parentField: isDependantField(col.name)
          ? {
              ...ticketAttributes.find(
                (el) => el.name === getParentField(col.name)
              ),
              label: getTranslatedText(
                intl,
                ticketAttributes.find(
                  (el) => el.name === getParentField(col.name)
                ).label
              )
            }
          : col,
        dependantField: isDependantField(col.name)
          ? col
          : ticketAttributes.find(
              (el) => el.name === getDependantField(col.name)
            ),
        isTrashView: viewId === '9'
      };
    });
    setColumnGroup(columns);
    setTicketListLoading(false);
  };

  const {
    loading: personalizationLoading,
    data: columnPersonalisation,
    refetch: refetchCols
  } = useCachedQuery(GET_PERSONALIZATION_BY_NAME, {
    variables: {
      userId: user.userId,
      category: 'TicketView',
      name: viewId
    },
    client: AccountClient
  });

  const refreshList = () => {
    refetchCols();
  };

  const getClosureFields = (errorFields) => {
    setClosureModalActive(true);
    setErrorsOnClosure({
      ticket: errorFields?.param.ticket,
      status: errorFields?.param?.status,
      fields: errorFields?.param?.fields
    });
  };

  const [updateTicket] = useMutation(UPDATE_TICKET, {
    client: TicketClient
  });

  const updateMyData = useCallback((newTicketData, diff) => {
    const newTableData = cloneDeep(dataByRef.current);
    const updatedTicketIndex = dataByRef.current.findIndex(
      (el) => el.ticketId === newTicketData.ticketId
    );
    const updatedDiff = omit(diff, ['id']);
    if (diff.client && newTicketData?.site) {
      updatedDiff.site = newTicketData.site;
    }
    if (diff.customFields && newTicketData?.customFields) {
      updatedDiff.customFields = newTicketData.customFields;
    }
    newTableData[updatedTicketIndex] = merge(
      newTableData[updatedTicketIndex],
      updatedDiff
    );
    setData(newTableData);
  }, []);

  const updateTicketOnClosure = (ticket, variables) => {
    setClosureSaveLoading(true);
    const ticketId = ticket?.ticketId;

    updateTicket({
      variables: {
        id: ticketId,
        ...variables
      }
    })
      .then((res) => {
        if (res?.data?.updateTicket) {
          setClosureModalActive(false);
          setErrorsOnClosure(null);
          setClosureSaveLoading(false);
          toast('success', 'app.toast.ticket.update.success');
          updateMyData(res?.data?.updateTicket, {
            id: ticketId,
            ...res?.data?.updateTicket,
            ...variables
          });
        } else {
          setClosureSaveLoading(false);
        }
      })
      .catch((err) => {
        setClosureSaveLoading(false);
      });
  };

  const save = (updatedProperties, ticket, oldData, callback) => {
    const diff = { ...updatedProperties };
    if (isEmpty(diff)) {
      callback && callback('success');
      return;
    }
    if (ticket.ticketId) {
      diff.id = ticket.ticketId;
    }
    if (diff.customFields) {
      const updatedDiff = getDifference(diff.customFields, ticket.customFields);
      diff.customFields = updatedDiff;
    }

    updateTicket({ variables: diff })
      .then((res) => {
        if (res?.data?.updateTicket) {
          updateMyData(res?.data?.updateTicket, {
            ...diff,
            customFields: res?.data?.updateTicket?.customFields
          });
          callback && callback('success');
          if (diff?.customFields) {
            toast('success', 'app.toast.ticket.update.success');
          }
        } else {
          callback && callback('error');
        }
      })
      .catch((err) => {
        callback && callback('error');
      });
  };

  const getActions = (col) => {
    switch (col.name) {
      case 'subject':
        return {
          onClick: context.openTicket,
          updateMyData,
          refreshTable: () => {
            EventEmitter.dispatch('refreshSuperList');
          }
        };

      default:
        return {
          save: save
        };
    }
  };

  // To check if we need to highlight the row
  const [isHighlighting, setIsHighLighting] = useState(false);

  const checkRowHighlight = (row) => {
    if (isHighlighting && liveUpdateTicketListRef.current?.length) {
      const ticketIdInRow = row?.original?.ticketId;
      return liveUpdateTicketListRef.current.find((el) => el === ticketIdInRow);
    }
  };

  // Function when live update is completed
  let timeoutId;
  const onLiveUpdateComplete = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (isLiveUpdatingRef.current) {
      setIsLiveUpdating(false);
      setShowLiveUpdate(false);
      setIsHighLighting(true);
      timeoutId = setTimeout(() => {
        liveUpdateTicketListRef.current = [];
        setIsHighLighting(false);
      }, 2500);
    }
  };

  const onSuccessCallback = () => {
    if (isLiveUpdatingRef.current) {
      onLiveUpdateComplete();
    }
  };

  // Function to call when refresh button is clicked
  const onLiveUpdateRefresh = () => {
    setIsLiveUpdating(true);
    EventEmitter.dispatch('refreshSuperList');
  };

  // Function called when there is an event from WS in superTable
  const onWebSocketEventMessage = (eventData) => {
    const payload = eventData?.payload;
    const type = payload?.type;
    const entity = payload?.page?.entity;
    const pageType = payload?.page?.type;
    const event = payload?.event;
    const updateTicketId = payload?.data?.record?.current?.ticketId;
    const wsWindowId = payload?.page?.windowId;
    if (
      type === 'SERVER_EVENT' &&
      pageType === 'LIST' &&
      entity === 'TicketView' &&
      wsWindowId === windowId
    ) {
      if (
        event === 'CREATE' ||
        event === 'ADD_TO_LIST' ||
        event === 'REMOVE_FROM_LIST' ||
        event === 'TRASH' ||
        event === 'UPDATE'
      ) {
        liveUpdateTicketListRef.current.push(updateTicketId);
        setShowLiveUpdate(true);
      }
      if (event === 'DELETE' && viewId === '9') {
        setShowLiveUpdate(true);
        liveUpdateTicketListRef.current.push(updateTicketId);
      }
    }
  };

  // Payload we need to send to Supertable for WS
  const WS_PAYLOAD = React.useMemo(() => {
    return {
      page: {
        type: 'LIST',
        entity: 'TicketView',
        windowId: windowId
      },
      data: {
        viewId: viewId,
        condition: listInfo?.condition || null,
        allowSimultaneousPage: false
      }
    };
  }, [windowId, viewId, listInfo?.condition]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    EventEmitter.subscribe('refreshList', refreshList);
    EventEmitter.subscribe('ticketClosureError', getClosureFields);
    setTimeout(() => {
      EventEmitter.dispatch('hideMonicaAi');
    }, 1000);

    return function cleanup() {
      EventEmitter.unsubscribe('refreshList');
      EventEmitter.unsubscribe('ticketClosureError');
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!personalizationLoading) {
      fetchViewData(columnPersonalisation);
    }
  }, [columnPersonalisation, personalizationLoading]);

  return (
    <div className="fhp super-table-container">
      <SuperList
        tableName={tableName}
        viewId={viewId}
        records={records}
        setRecords={setRecords}
        tableCondition={tableCondition}
        advanceFilterCondition={advanceFilterCondition}
        columns={columnGroup}
        data={data}
        setData={setData}
        isLoading={ticketListLoading || isLiveUpdating}
        dynamicRowCount={!!dynamicPaginationFlag}
        columnWidthPersonalization
        defaultColumnCells={defaultColumn}
        noBulkSelect={!isTicketEditAuthorised}
        checkBoxDisabledCheck={isCheckBoxInactive}
        editCellId={editCellId}
        enableLiveUpdate={
          isMSP && flags?.ticketListviewPageRefresh && !props?.disableLiveUpdate
        } // flag to enable live update
        wsPayload={WS_PAYLOAD} // Payload to send for websocket
        liveUpdateCondition={listInfo?.condition}
        // Whenever this prop changes we'll call update WS with updated conditions
        onMessage={onWebSocketEventMessage}
        // function when we recieve websocket event
        // Based on the data we'll set showLiveUpdate state
        showLiveUpdate={showLiveUpdate} // To show refresh button
        onLiveUpdateRefresh={onLiveUpdateRefresh}
        // Action to do when refresh button is clicked
        // This is Optional this will be taken care by the table itself if not passed
        isLiveUpdateInProgress={isLiveUpdating} // To make refresh button in loading state
        checkRowHighlight={checkRowHighlight} // To check if row is highlighted
        refreshButtonStyles={{
          '.refresh-notification': {
            // Target the class directly
            left: '40% !important'
          }
        }}
        emptyState={{
          // nodataImage: `${envConfig.imageRoot}svg/TicketEmptyState.svg)`,
          nodataImage: `${envConfig.imageRoot}svg/TicketEmptyState.svg`,
          heading: getTranslatedText(intl, 'alert.noTicketsFound.heading'),
          description: getTranslatedText(intl, 'alert.noTicketsFound.desc')
        }}
        registerPageDelay={100}
        defaultSort={DEFAULT_SORT}
        appendViewIdToListInfo
        queryGenerator={{
          operation: 'getTicketList',
          getVariables: getQueryVariables,
          getFields: () => {
            return getTicketFields(coulumsRef.current, isMSPProduct);
          }
        }}
        client={TicketClient}
        accessorKey="getTicketList"
        dataKey="tickets"
        onSuccessCallback={onSuccessCallback}
        refreshEventEmitters={['refreshSuperList']}
        sortingPersonalization
        useWatchQuery
      />

      {errorsOnClosureByRef.current && (
        <>
          <ClosureModal
            modalActive={closureModalactive}
            setModalActive={setClosureModalActive}
            errorsOnClosure={errorsOnClosureByRef.current}
            setErrorsOnClosure={setErrorsOnClosure}
            onSave={updateTicketOnClosure}
            saveLoading={closureSaveLoading}
            onClose={() => setClosureModalActive(false)}
          />
        </>
      )}
    </div>
  );
}

export default injectIntl(withRouter(TicketContainerNew));
